import { render, staticRenderFns } from "./SavedGroup.vue?vue&type=template&id=4f6f8228"
import script from "./savedGroup.ts?vue&type=script&lang=ts&external"
export * from "./savedGroup.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports